import Vue from "vue";
import PartnerDescription from '../components/admin/PartnerDescription.vue';
import { AppercodeFile } from "@api/models/File";
import { ExhibitionModel } from "@api/models/exhibition/ExhibitionModel";

const renderDescription = (partner: ExhibitionModel, changes: Record<string, any>, files: AppercodeFile[] = [], lang = 'en') => {
    const tempComponent = Vue.extend({
        render: (createElement) => {
            return createElement(PartnerDescription, {
                props: {
                    partner,
                    changes,
                    files,
                    lang
                }
            })
        }
    });

    let testComponentInstance = new tempComponent();
    testComponentInstance.$mount();
    const html = testComponentInstance.$el.innerHTML;
    testComponentInstance.$destroy();
    testComponentInstance = null as any;

    return html;
}

export {renderDescription}
